"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWxSignatureForJkt = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var jktwx_1 = require("../../model/jktwx");
var service_1 = require("../../../library/base/service");
var GetWxSignatureForJkt = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetWxSignatureForJkt, _super);
    function GetWxSignatureForJkt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取微信签名';
        _this.code = '300101';
        _this.desc = '获取微信签名';
        _this.requestParams = new jktwx_1.GetWxSignatureForJktRequest();
        _this.method = fetch_1.Methods.GET;
        return _this;
    }
    return GetWxSignatureForJkt;
}(service_1.BaseService));
exports.GetWxSignatureForJkt = GetWxSignatureForJkt;
//# sourceMappingURL=getWxSignatureForJkt.js.map